import InvestmentTypeWidget from './InvestmentTypeWidget'

export default InvestmentTypeWidget
